import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { useTheme } from '../../theme';
import { ModalX } from '../../BaseComponents';
import { ModalXProps } from '../../BaseComponents/ModalX/components/ModalX';
import CustomerContactsForm, { Props as CustomerContactsProps } from '../CustomerContactsForm';

type Props = ModalXProps & CustomerContactsProps;

const CustomerContactsModal: React.FC<Props> = ({ initialValues, onContactsSubmit, isLoading, ...props }) => {
	const { t } = useTranslation('CustomerContactsForm');
	const { CustomerContactsModal: css } = useTheme('CustomerContactsForm');

	return (
		<ModalX
			size="medium"
			title={<span className={css.saveContactInfo__title}>{t('Please, enter your contacts')}</span>}
			{...props}
		>
			<CustomerContactsForm
				initialValues={initialValues}
				onContactsSubmit={onContactsSubmit}
				isLoading={isLoading}
			/>
		</ModalX>
	);
};

export default CustomerContactsModal;
